// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--28I70"};